import './style.css';

function ButtonPedidos({ type }) {
  const icon =
    type === 'Detalhes' ? (
      <i className="far fa-eye" />
    ) : (
      <i className="fas fa-check" />
    );

  return (
    <button className="btn btn-pedidos d-flex flex-column align-items-center justify-content-center">
      {icon}
      {type}
    </button>
  );
}

export default ButtonPedidos;
